<template>
     <TabHeader  />      
     
        <v-card  elevation="16" variant="outlined" class="mx-auto my-8" bg-color="00146a">
          <v-card-item>
          <v-card-title style="color:#0f58b7">Création d'une fiche patient</v-card-title>
     <v-card-text>
      <v-container   style="border-color: #0f58b7;border-style: solid;border-width: 0.5px;">
    <v-row>
        <v-chip-group >
            <v-chip :class="classHo" color="blue" @click="civility('Homme')" >Homme
            </v-chip>
            <v-chip  :class="classFe" color="pink"  @click="civility('Femme')"> Femme
            </v-chip>            
        </v-chip-group>
    </v-row>
    <v-row>
      <v-col
          cols="12"
          sm="4"
        >
        <v-text-field  variant="outlined" label="Nom"  v-model="data.nom"    :rules="[rules.required]"></v-text-field>
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
        <v-text-field   variant="outlined" label="Prénom" v-model="data.prenom"    :rules="[rules.required]"></v-text-field>
   </v-col>
   <v-col
          cols="12"
          sm="4"
        >
        <v-text-field    type="date" variant="outlined" label="Date de naissance" v-model="data.dateNaissance"></v-text-field>
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
        <v-text-field   variant="outlined" label="N° Sécurité sociale" v-model="data.numSecu"></v-text-field>
</v-col>
<v-col
          cols="6"
          sm="4"
        >
        <v-text-field variant="outlined" label="Adresse" v-model="data.adresse"></v-text-field>
        </v-col>
        <v-col
          cols="3"
          sm="2"
        >
        <v-text-field variant="outlined" label="Code Postal" v-model="data.codePostal"></v-text-field>
        </v-col>
        <v-col
          cols="3"
          sm="2"
        >
        <v-text-field variant="outlined" label="Ville" v-model="data.ville"></v-text-field>
        </v-col>
        <v-col
          cols="6"
          sm="4"
        >
        <v-text-field variant="outlined" label="Tel" type="number" v-model="data.tel" placeholder="Numero de Téléphone du patient"></v-text-field>
        </v-col>
        <v-col
          cols="6"
          sm="4"
        >
        <v-text-field variant="outlined" label="Prestataire" v-model="data.prestataire"></v-text-field>
        </v-col>
        <v-col
          cols="6"
          sm="4"
        >
        <v-text-field
        label="Médecin"     
        v-model="data.medecin"       
        variant="outlined"
        ></v-text-field> 
        <!-- <v-combobox
        label="Médecin"
        :items="listMedecin.map(function (item) { return item.prenom + ' ' + item.nom; })"
        v-model="data.medecin"       
        variant="outlined"
        ></v-combobox> -->
          
    </v-col>  </v-row>
    <v-row>
        <v-textarea variant="outlined"  label="Motif de la prise en charge" v-model="data.motif" ></v-textarea>
        
    </v-row>

    <v-row justify="center" v-if="this.$route.name!='viewPatient'">
        <v-btn   @click="valider"
         variant="elevated" 
         label="Valider" 
         color="blue-darken-4"
         class="text-none ms-4 text-white"
         :disabled="!isValid()">Valider</v-btn>
        <v-btn  
        color="red-darken-4"
         class="text-none ms-4 text-white"
        @click="this.$router.push('/patient');"  variant="elevated" label="Annuler">Annuler</v-btn>
    </v-row>

      </v-container>
      </v-card-text>
      </v-card-item>
  
      </v-card>

<!-- </v-expansion-panel>

</v-expansion-panels>  -->

</template> 
<script>

import http from '../../http.js'
import TabHeader from './TabHeader.vue'
export default {
    data: () => ({
        rules: {
            required: value => !!value || "Le champ est obligatoire",
        },
        classHo: null,
        classFe: null,
        classH: "v-chip v-chip--link v-theme--light text-blue v-chip--density-default v-chip--size-default v-chip--variant-tonal v-chip--selected",
        classF: "v-chip v-chip--link v-theme--light text-pink v-chip--density-default v-chip--size-default v-chip--variant-tonal v-chip--selected",
        class: "v-chip v-chip--link v-theme--light v-chip--density-default v-chip--size-default v-chip--variant-tonal",
        form: false,
        email: null,
        listMedecin: [],
        idPatient: null,
        password: null,
        loading: false,
        disable: false,
        data: {}
    }),
    mounted() {
        if (this.$route.name == "viewPatient") {
            this.disable = true;
        }
        else {
            this.disable = false;
        }
        this.idPatient = this.$route.params.id;
        if (this.$route.params.id != undefined) {
            //  http.get("/api/patient/"+this.$route.params.id).then(resp=>this.data=resp.data);
            http.get("/api/patient/" + this.$route.params.id).then(resp => { this.data = resp.data;localStorage.setItem("nomPatient",this.data.prenom+" "+this.data.nom); if (this.data.civilite == "Homme") {
                this.classHo = this.classH;
            }
            else
                this.classFe = this.classF; });
        }
        http.get("/api/medecin").then(resp => { this.listMedecin = resp.data; });
    },
    methods: {
        isValid() {
            return this.data.nom != undefined
                && this.data.prenom != undefined
                && this.data.civilite != undefined;
        },
        getMedecinId(name){  
            const listId=this.listMedecin.filter(data=>{ return name === data.prenom + " " + data.nom}).map(x=>x.id);          
            return listId?.length>0?listId[0]:null;
        },
        valider() {
            // const medecinId = this.getMedecinId(this.data.medecin);
            // if(medecinId){
            //     this.data.medecinId = medecinId;
            // }
          
            http.post("/api/patient", this.data)
                .then(this.$router.push("/patient")).catch(function (error) {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
            });
        },
        civility(item) {
            this.data.civilite = item;
            if (item == "Homme") {
                return this.classFe = this.class;
            }
            if (item == "Femme") {
                return this.classHo = this.class;
            }
        },
        afficherTab() {
            return true;
        },
        getId() {
            return this.$route.params.id;
        },
        showTab() {
            return this.$route.name != "NouveauPatient";
        }

    },
    components: { TabHeader }
}
</script>